// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import styled from "@emotion/styled";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
// Authentication layout components
import PageLayout from "examples/LayoutContainers/PageLayout";
import Cookies from "js-cookie";

//custom components
import Header from "./components/header.js";
import MainSection from "./components/main-section.js";
import Footer from "./components/footer.js";
import BodySection from "./components/body-section.js";
import Pricing from "./Pricing.js";
import { Helmet } from "react-helmet-async";

//styled components
const MainWrapper = styled.div`
  backgroundcolor: #ffffff;
  overflow: hidden;
`;

function Home() {
  const location = useLocation();

  useEffect(() => {
    let token = location?.search?.replace("?code=", "");
    if (token) {
      const in60Seconds = new Date(new Date().getTime() + 60 * 1000);
      Cookies.set("fbAccessCode", token, { expires: in60Seconds });
      // Wait for a short delay before dispatching the event
      setTimeout(() => {
        // window.dispatchEvent(new Event('cookieChanged'));
        window.close();
      }, 100); // Small delay (100ms) ensures the cookie is set before dispatching the event
    }
  }, []);

  return (
    <PageLayout>
      <MainWrapper>
        <MDBox sx={{ position: "relative" }}>
          <MDBox sx={{ position: "absolute", right: "-22%", bottom: "-38%" }}>
            {" "}
            <MDBox
              sx={{
                width: "803px",
                height: "803px",
                borderRadius: "803px",
                opacity: "0.1",
                background: "#318BEC",
                filter: "blur(150px)",
              }}
            ></MDBox>
          </MDBox>

          <MDBox>
            <Helmet>
              <title>#1 AI Platform for Restaurants, Cafe and Bars</title>
              <meta
                name="description"
                content="Grow your restaurant, cafe & bar with an AI platform for business intelligence, marketing automation and reputation management to boost growth and loyalty"
              />
              <meta name="keywords" content="AI Platform" />
            </Helmet>
            <Header></Header>

            <MainSection></MainSection>
          </MDBox>
        </MDBox>

        <BodySection></BodySection>

        <Footer></Footer>
      </MainWrapper>
    </PageLayout>
  );
}

export default Home;
